<template>
  <div class="tab-pane" id="addBadge" role="tabpanel">
    <validation-observer ref="registerForm" #default="{ invalid }">
      <b-row>
        <b-col md="6">
          <!-- .first_name -->
          <b-form-group
            id="input-group-27"
            :label="$t('students.first_name')"
            label-for="input-27"
          >
            <b-form-input
              id="input-27"
              v-model="newItem.first_name"
              type="text"
              :placeholder="$t('students.first_name')"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <!-- .last_name -->
          <b-form-group
            id="input-group-28"
            :label="$t('students.last_name')"
            label-for="input-28"
          >
            <b-form-input
              id="input-28"
              v-model="newItem.last_name"
              type="text"
              :placeholder="$t('students.last_name')"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <!-- .first_name -->
          <b-form-group
            id="input-group-27"
            :label="$t('students.first_name_en')"
            label-for="input-27"
          >
            <b-form-input
              id="input-27"
              v-model="newItem.first_name_en"
              type="text"
              :placeholder="$t('students.first_name_en')"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <!-- .last_name -->
          <b-form-group
            id="input-group-28"
            :label="$t('students.last_name_en')"
            label-for="input-28"
          >
            <b-form-input
              id="input-28"
              v-model="newItem.last_name_en"
              type="text"
              :placeholder="$t('students.last_name_en')"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <!-- .email -->
          <b-form-group
            id="input-group-2"
            :label="$t('users.email')"
            label-for="input-2"
          >
            <b-form-input
              id="input-2"
              v-model="newItem.email"
              type="text"
              :placeholder="$t('users.email')"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-checkbox
            name="check-button"
            v-if="newItem.id"
            v-model="changePassword"
            value="1"
            switch
            inline
          >
            {{ $t("users.change_password") }}
          </b-form-checkbox></b-col
        >
        <b-col md="3" v-if="!newItem.id || changePassword == 1">
          <!-- .email -->
          <b-form-group
            :label="$t('users.password')"
            label-for="reset-password-new"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('users.password')"
              vid="Password"
              rules="required|password"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="reset-password-new"
                  v-model="newItem.password"
                  :type="password1FieldType"
                  :state="errors.length > 0 ? false : null"
                  class="form-control-merge"
                  name="reset-password-new"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    class="cursor-pointer"
                    :icon="password1ToggleIcon"
                    @click="togglePassword1Visibility"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="3" v-if="!newItem.id || changePassword == 1">
          <!-- .email -->
          <b-form-group
            label-for="reset-password-confirm"
            :label="$t('users.password_confirmation')"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('users.password_confirmation')"
              rules="required|confirmed:Password"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="reset-password-confirm"
                  v-model="newItem.password_confirmation"
                  :type="password2FieldType"
                  class="form-control-merge"
                  :state="errors.length > 0 ? false : null"
                  name="reset-password-confirm"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    class="cursor-pointer"
                    :icon="password2ToggleIcon"
                    @click="togglePassword2Visibility"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <!-- .active_status -->
      </b-row>
      <hr />
      <b-row>
        <b-col md="4">
          <!-- .birth_date -->
          <b-form-group
            id="input-group-33"
            :label="$t('students.birth_date')"
            label-for="input-33"
          >
            <validation-provider
              #default="{ errors }"
              name="country"
              vid="country"
              rules="required"
            >
              <flat-pickr
                v-model="newItem.birth_date"
                class="form-control"
                :config="{ dateFormat: 'm/d/Y' }"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="4">
          <!-- .profile_image -->
          <b-form-group
            id="input-group-10"
            :label="$t('users.profile_image')"
            label-for="input-10"
          >
            <input
              type="file"
              name="image"
              accept="image/*"
              class="form-control load-image"
              @change="previewImage($event)"
            />
            <img
              v-if="url != null"
              width="200"
              height="200"
              :src="url"
              class="loaded-image"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <!-- .gander -->
          <b-form-group
            id="input-group-42"
            :label="$t('students.gander')"
            label-for="input-42"
          >
            <b-form-radio
              v-model="newItem.gender"
              name="some-radios"
              value="male"
            >
             {{ $t("site.male") }}
            </b-form-radio>
            <b-form-radio
              v-model="newItem.gender"
              name="some-radios"
             value="female"
            >
               {{ $t("site.female") }}
            </b-form-radio>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <!-- .mobile -->
          <b-form-group
            id="input-group-13"
            :label="$t('students.mobile')"
            label-for="input-13"
          >
            <b-form-input
              id="input-13"
              v-model="newItem.mobile"
              type="text"
              :placeholder="$t('students.mobile')"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <!-- .nationality -->
          <b-form-group
            id="input-group-29"
            :label="$t('master.nationalities')"
            label-for="input-29"
          >
            <validation-provider
              #default="{ errors }"
              name="nationality"
              vid="nationality"
              rules="required"
            >
              <v-select
                dir="rtl"
                id="input-30"
                v-model="newItem.nationality_id"
                :options="citizenship"
                :reduce="(country) => country.Code"
                label="NameAr"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <!-- .country -->

          <b-form-group
            id="input-group-30"
            :label="$t('countries.country')"
            label-for="input-30"
          >
            <validation-provider
              #default="{ errors }"
              name="country"
              vid="country"
              rules="required"
            >
              <v-select
                dir="rtl"
                id="input-30"
                v-model="newItem.country_id"
                :reduce="(country) => country.Code"
                label="NameAr"
                :options="citizenship"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <!-- .department -->
          <b-form-group
            id="input-group-30"
            :label="$t('roles.roles')"
            label-for="input-30"
          >
            <v-select
              dir="rtl"
              id="input-30"
              v-model="newItem.role "
              :reduce="(item) => item.name"
              label="name"
              :options="roles"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <hr />
      <b-row >
        <b-col md="6">
          <!-- .degree -->
          <b-form-group
            id="input-group-31"
            :label="$t('ac_qualifications.ac_qualifications')"
            label-for="input-31"
          >
            <v-select
              dir="rtl"
              id="input-30"
              v-model="newItem.degree_id"
              :reduce="(country) => country.id"
              label="name"
              :options="acQualifications"
            />
          </b-form-group>
        </b-col>

        <b-col md="3">
          <!-- .graduation_year -->
          <b-form-group
            id="input-group-41"
            :label="$t('students.graduation_year')"
            label-for="input-41"
          >
            <b-form-input
              id="input-41"
              v-model="newItem.graduation_year"
              type="text"
              :placeholder="$t('students.graduation_year')"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <!-- .graduation_year -->
              <b-form-group
                id="input-group-1"
                :label="$t('students.master_student')"
                label-for="input-1"
              >      
                <b-form-checkbox
                      v-model="newItem.master_supervise"
                      class="custom-control-info"
                      name="check-button"
                      value="2"
                      switch
                /> 
              </b-form-group>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col lg="6">
          <b-button
            block
            :disabled="invalid"
            variant="primary"
            @click="submit()"
          >
            <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
          >
        </b-col>
        <b-col lg="6">
          <b-button block  @click="goToTable()"  variant="success">
            <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
          >
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>

<script>
import Controller from "../../../../Controllers/UsersController";
import config from "../../../../config/config";
const controller = new Controller();
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import { required, email } from "@validations";
import DepartmentsController from "@/Controllers/DepartmentsController";
import Ac_qualificationsController from "@/Controllers/Ac_qualificationsController";
import DegreesController from "@/Controllers/DegreesController";
import flatPickr from "vue-flatpickr-component";
import MediuEduController from "@/Controllers/MediuEduController";
import RolesController from '@/Controllers/RolesController';

export default {
  name: "UsersForm",
  props: ["newItem"],
  components: {
    // validations
    ValidationProvider,
    ValidationObserver,
    vSelect,
    required,
    email,
    flatPickr,
  },
  data() {
    return {
      file: {},
      
      provider: [],
      citizenship: [],
      departmentsOptions: [],
      degrees: [],
      roles: [],
      acQualifications: [],
      // Toggle Password
      password1FieldType: "password",
      password2FieldType: "password",
      routeName: this.$route.name,
      url: null,
      changePassword: 0,
    };
  },
  async created() {
    const ct = new MediuEduController();

    this.citizenship = await ct.GetCitizenship();
    this.departmentsOptions = await new DepartmentsController().GetAll();
    this.acQualifications = await new Ac_qualificationsController().GetAll();
    this.degrees = await new DegreesController().GetAll();
    this.roles = await new RolesController().GetAll();
  },
  computed: {
    password1ToggleIcon() {
      return this.password1FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password2ToggleIcon() {
      return this.password2FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    route() {
      return this.routeName;
    },
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      if (this.routeName == "Users") {
        this.newItem.account_type = "admin";
      } else if (this.routeName == "Teachers") {
        this.newItem.account_type = "teacher";
      } else if (this.routeName == "Students") {
        this.newItem.account_type = "student";
      }
      let ret = await controller.From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
    togglePassword1Visibility() {
      this.password1FieldType =
        this.password1FieldType === "password" ? "text" : "password";
    },
    togglePassword2Visibility() {
      this.password2FieldType =
        this.password2FieldType === "password" ? "text" : "password";
    },
    previewImage(event) {
      console.log("event", event.target.files[0]);
      const _file = event.target.files[0];

      this.newItem.profile_image = _file;
      this.url = URL.createObjectURL(_file);
    },
  },
  watch: {
    newItem(value, r) {
      if (value.account_type) {
        console.log(value);

        // this.$set(this, "routeName", "Teacher");
        // console.log(this.routeName);
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>